import { createFileRoute } from "@tanstack/react-router";
import AdminReportDashboardPage from "@/admin/pages/report-dashboard";
import { validateReportSearch, type ReportSearch } from "@/admin/reporting/url-state";

export const Route = createFileRoute("/admin/reports/d/$slug")({
  component: Page,
  validateSearch: (search: Record<string, unknown>): ReportSearch => validateReportSearch(search),
});

function Page() {
  const { slug } = Route.useParams();
  const search = Route.useSearch();
  return <AdminReportDashboardPage slug={slug} search={search} />;
}
